export var SecurityRoleItems = {
  DashboardTopStats: "Dashboard Statistics Setup",
  Dashboard: "Dashboard",
  MyJobs: "My Jobs",
  MyRequisition: "My Requisition",
  MyNewStarters: "My New Starters",
  ExportMyNewStarters: "Export My New Starters",
  OBHubRemoveFromProcess: "OB Hub - Remove From Process",
  MyCommunications: "My Communications",
  MyCalendar: "My Calendar",
  MyTalentPools: "My Talent Pools",
  MySavedSearches: "My Saved Searches",
  MyNotes: "My Notes",
  Jobs: "Jobs",
  TalentPool: "Talent Pool",
  TalentCapture: "Talent Capture",
  TalentCommunity: "Talent Community",
  SearchCandidates: "Search Candidates",
  SearchByKeywords: "Search By Keywords",
  SearchbyPostcode: "Search by Postcode",
  SaveSearch: "Save Search",
  Search_MyReferences: "Search: My Reference",
  Search_MyNewStarters: "Search: My New Starters",
  SmartSearch: "AllowTextKernelSearch",
  AllowApplicationSearch: "AllowApplicationSearch",
  AssignToTalentPool: "Assign To Talent Pool",
  SearchJobAlerts: "Search Job Alerts",
  CalendarEntries: "Calendar Entries",
  ListofEvents: "List of Events",
  Emails_EmailTemplates: "Emails: Email Templates",
  Emails_Inbox: "Emails: Inbox",
  Emails_Outbox: "Emails: Outbox",
  Letters_LetterTemplates: "Letters: Letter Templates",
  Letters_LetterContracts: "Letters: Contracts",
  Letters_LetterContractSections: "Letters: Contract Sections",
  Letters_LetterContractImage: "Letters: Contract Images",
  SMS_SMSTemplates: "SMS: SMS Templates",
  SMS_Inbox: "SMS: Inbox",
  SMS_Outbox: "SMS: Outbox",
  SystemSetup_SystemSettings: "System Setup: System Settings",
  SystemSetup_SystemUsers: "System Setup: System Users",
  SystemSetup_SecurityRoles: "System Setup: Security Roles",
  SystemSetup_Teams: "System Setup: Teams",
  SystemSetup_AIOrganisationalContextData: "System Setup: AI Organisational Context Data",
  SystemSetup_RequisitionUsers: "System Setup: Requisition Users",
  SystemSetup_AuthorisationGroups: "System Setup: Authorisation Groups",
  SystemSetup_RequisitionSchemes: "System Setup: Requisition Schemes",
  AssessmentForms_AssessmentFormSetup: "Assessment Forms: Assessment Form Setup",
  AssessmentForms_QuestionsBank: "Assessment Forms: Questions Bank",
  ApplicationTemplates: "Application Templates",
  ApplicationTemplates_TemplatesSetup: "Application Templates: Templates Setup",
  ApplicationTemplates_CustomFields: "Application Templates: Custom Fields",
  ApplicationTemplates_DirectApplyApplicationForm: "Application Templates: Direct Apply Application Form",
  GeneralSetup: "General Setup",
  GeneralSetup_Languages: "General Setup: Languages",
  GeneralSetup_Package: "General Setup: Package",
  GeneralSetup_JobCode: "General Setup: JobCode",
  GeneralSetup_FirstAdvPin: "General Setup: First Adv Pins",
  GeneralSetup_DocumentLibrary: "General Setup: Document Library",
  GeneralSetup_Adverts: "General Setup: Adverts",
  GeneralSetup_RedeploymentStatus: "General Setup: Redeployment Status",
  GeneralSetup_RedeploymentWithdrawReason: "General Setup: Redeployment Withdraw Reason",
  GeneralSetup_RedeploymentForm: "General Setup: Redeployment Form",
  GeneralSetup_ExternalConsultancies: "General Setup: External Consultancies",
  GeneralSetup_AdvertCategories: "General Setup: Advert Categories",
  GeneralSetup_JobCategories: "General Setup: Job Categories",
  GeneralSetup_JobRegions: "General Setup: Job Regions",
  GeneralSetup_StandardApplicationStatus: "General Setup: Standard Application Status",
  GeneralSetup_SalaryBands: "General Setup: Salary Bands",
  GeneralSetup_SalaryBandYears: "General Setup: Salary Band Years",
  GeneralSetup_EthnicOrigins: "General Setup: Ethnic Origins",
  GeneralSetup_Departments: "General Setup: Departments",
  GeneralSetup_Locations: "General Setup: Locations",
  CorporateAccountSetup: "Email Integration: Corporate Account Setup",
  GeneralSetup_JobLevels: "General Setup: Job Levels",
  GeneralSetup_Divisions: "General Setup: Divisions",
  GeneralSetup_Specialisms: "General Setup - Specialisms",
  GeneralSetup_Campaigns: "General Setup: Campaigns",
  GeneralSetup_JobTitles: "General Setup: Job Titles",
  GeneralSetup_AddressBook: "General Setup: Address Book",
  TalentPoolApplicationTemplateSetup: "Talent Pool Application Template Setup",
  GeneralSetup_SchoolLocations: "General Setup: School Locations",
  GeneralSetup_SkillCategory: "General Setup- Skill Category",
  GeneralSetup_StatusChangeReason: "General Setup: Status Change Reason",
  GeneralSetup_Skills: "General Setup- Skills",
  GeneralSetup_NHSAccountCodes: "General Setup- NHSAccountCodes",
  GeneralSetup_NHSBanks: "General Setup: Banks",
  GeneralSetup_NHSJKLBand: "General Setup: JKLBand",
  GeneralSetup_NHSAvailabilitySupplement: "General Setup: Availability Supplement",
  GeneralSetup_Automation: "General Setup: Job Status Automation",
  Feature_JobStatus_Automation: "Feature_JobStatus_Automation",
  feature_yoti: "feature-yoti",
  feature_multi_education: "feature-multi-education",
  Feature_WithdrawnStatus_Reason: "Feature_WithdrawnStatus_Reason",
  GeneralSetup_NHSCostCodes: "General Setup- NHSCostCodes",
  GeneralSetup_NHSBoardPositions: "General Setup- NHSBoardPositions",
  GeneralSetup_JobTemplates: "General Setup- JobTemplates",
  GeneralSetup_Specialties: "General Setup - Specialties",
  GeneralSetupPositions: "General Setup: Positions",
  GeneralSetup_Logos: "Job Board Marketplace - Logos",
  GeneralSetupColleagueCategory: "General Setup: Colleague Category",
  GeneralSetup_WorkPattern: "General Setup: Work Pattern",
  GeneralSetupPostReference: "General Setup: PostReference",
  GeneralSetupJtAssets: "General Setup: JT_Assets",
  GeneralSetupFundingSource: "General Setup: Funding Sources",
  TrustIdBranch: "Trust ID Branch",




  GeneralSetup_NHSStaffGroups: "General Setup- NHSStaffGroups",
  GeneralSetup_NHSJobDescriptions: "General Setup- NHSJobDescriptions",
  SystemSetup: "System Setup",
  AssessmentForms: "Assessment Forms",
  Emails: "Emails",
  Letters: "Letters",
  SMS: "SMS",
  Candidates: "Candidates",
  JobAlerts: "Job Alerts",
  ListCandidate: "List Candidate",
  ListCandidate_Reinstate: "List Candidate - Reinstate",
  Reports: "Reports",
  ListCandidate_History: "List Candidate - History",
  ListCandidate_CV: "List Candidate - CV",
  ListCandidate_DownloadCoverLetter: "List Candidate - Download Cover Letter",
  ListCandidate_Interview: "List Candidate - Interview",
  ListCandidate_UpdateStatus: "List Candidate - Update Status",
  ListCandidate_AssigntoaJob: "List Candidate - Assign to a Job",
  ListCandidate_AssigntoaTalentPool: "List Candidate - Assign to a Talent Pool",
  ListCandidate_AddNotes: "List Candidate - Add Notes",
  ListCandidate_Checklist: "List Candidate - Checklist",
  ListCandidate_StarterForm: "List Candidate - Starter Form",
  ListCandidate_StarterFormExport: "List Candidate - Starter Form - Export",
  ListCandidate_OnlineInterview: "List Candidate - Online Interview",
  HideSettingsIcon: "Hide Settings Icon",
  ListCandidate_StarterForm2: "List Candidate - Starter Form2",
  ListCandidate_StartOnboarding: "List Candidate - Start Onboarding",
  ListCandidate_UploadManualReferences: "List Candidate - Upload Manual References",
  ListCandidate_StartCompliance: "List Candidate - Start Compliance",
  ListCandidate_StartGreenRoom: "List Candidate - Start GreenRoom",
  ListCandidate_StartReferences: "List Candidate - Start References",
  ListCandidate_CandidatePackOnlineReferences: "List Candidate - Candidate Pack Online References",
  EditReference: "Add Reference",
  ListCandidate_BankDetails: "List Candidate - Bank Details",
  ListCandidate_SendEmail: "List Candidate - Send Email",
  ListCandidate_SendToiTrent: "List Candidate - Send to iTrent",
  ListCandidate_SendToiTrentDlxDocumentOnly: "List Candidate - Send to iTrent Dlx Document Only",
  ListCandidate_SendToSapCloud: "List Candidate - Send to Sap Cloud",
  ListCandidate_SendToPrioryiTrent: "List Candidate - Send to PrioryiTrent",
  ListCandidate_ResendToiTrent: "List Candidate - Resend to iTrent",
  ListCandidate_SendToUoBAT: "List Candidate - Send to UoBAT",
  ListCandidate_ResendToUoBAT: "List Candidate - Resend to UoBAT",
  ListCandidate_DownloadNtuiTrentCsvFiles: "List Candidate - Download Ntu iTrent Csv Files",
  ListCandidate_DownloadSapCloudFile: "List Candidate - Download Sap Cloud File",
  ListCandidate_HRForm: "List Candidate - HR Form",
  ListCandidate_SendLetter: "List Candidate - Send Letter",
  ListCandidate_ForwardDetails: "List Candidate - Forward Details",
  ListCandidate_EmailReference: "List Candidate - Email Reference",
  ListCandidate_LetterReference: "List Candidate - Letter Reference",
  ListCandidate_PrintContract: "List Candidate - Print Contract",
  ListCandidate_OpportunityAlerts: "List Candidate - Opportunity Alerts",
  ListCandidate_AppliedJobs: "List Candidate - Applied Jobs",
  ListCandidate_ExternalInternal: "List Candidate - External/Internal",
  ListCandidate_EmailNewPassword: "List Candidate - Email New Password",
  ListCandidate_UnlockAccount: "List Candidate - Unlock Account",
  ListCandidate_ViewUpdateDocuments: "List Candidate - View & Update Documents",
  ListCandidate_SentEmails: "List Candidate - Sent Emails",
  ListCandidate_ReceivedEmails: "List Candidate - Received Emails",
  ListCandidate_SentLetters: "List Candidate - Sent Letters",
  ListCandidate_OfferAuthorisation: "List Candidate - Offer Authorisation",
  ListCandidate_SendText: "List Candidate - Send Text",
  ListCandidate_eEssForm: "List Candidate - eEss Form",
  ListCandidate_AdditionalStarterForm: "List Candidate - Additional Starter Form",
  ListCandidate_AdditionalChecklistForm: "List Candidate - Additional Checklist Form",
  ListCandidate_Psychometrics: "List Candidate - Psychometrics",
  ListCandidate_VideoInterview: "List Candidate - Video Interview",
  FeatureVideo: "FeatureVideo",
  ListCandidate_PrintExport: "List Candidate - Print & Export",
  ListCandidate_Shortlisting: "List Candidate - Shortlisting",
  SystemSetup_MultipleDocumentsUpload: "System Setup: Multiple Documents Upload",
  ListCandidate_2ndStageApplication: "List Candidate - 2nd Stage Application",
  ListCandidate_BullkForward: "List Candidate - Bullk Forward",
  ListCandidate_ForwardSingle: "List Candidate - Forward Single",
  ListCandidate_SpecialAdjustment: "List Candidate - Special Adjustment",
  ListCandidate_Preassessment: "List Candidate - Pre-assessment",
  ListCandidate_SendToCiphr: "List Candidate - Send to Ciphr",
  ListCandidate_DownloadCiphrFile: "List Candidate - Download Ciphr File",
  ListCandidate_SendToPeopleHR: "List Candidate - Send to PeopleHR",
  ListCandidate_DownloadPeopleHR: "List Candidate - Download File PeopleHR",
  OBDB_DataMigration: "OBDB_DataMigration",
  ListCandidate_FailedEmailIcon: "List Candidate - Failed Email Icon",
  ListCandidate_InternalIcon: "List Candidate - Internal Icon",
  ListCandidate_TotalApplicationsIcon: "List Candidate - Total Applications Icon",
  ListCandidateArmedForcesIcon: "List Candidate - Icon - Veteran/Armed Forces",
  ListCandidateCustomIcon: "List Candidate - Icon - Custom Icon",
  ListCandidate_Redeployment: "List Candidate - Redeployment",
  ListCandidate_REDCIRCLE: "List Candidate - REDCIRCLE",
  ListCandidate_TwoTicks: "List Candidate - Two Ticks",
  ListCandidate_AgencyEmployed: "List Candidate - Agency Employed",
  ListCandidate_CustomFieldsIcon: "List Candidate - Custom Fields Icon",
  ListCandidate_AddedBy: "List Candidate - Added By",
  ListCandidate_CriminalConviction: "List Candidate - Criminal Conviction",
  ListCandidate_EditApplicationStatusIcon: "List Candidate - Edit Application Status Icon",
  ListCandidate_EmploymentGap: "List Candidate - Employment Gap",
  ListCandidate_NotifyIcon: "List Candidate - Notify Icon",
  ListCandidate_EqualOppsIcon: "List Candidate - Equal Opps Icon",
  ListCandidate_DisabilityIcon: "List Candidate - Disability Icon",
  ListCandidate_RestoreMissingFields: "List Candidate - Restore Missing Fields",
  TalentPool_Region: "Talent Pool - Region",

  Allocated_Candidates: "List Candidate - Allocated Candidates",
  UnAllocated_Candidates: "List Candidate - UnAllocated Candidates",
  New_Candidates: "List Candidate - New Candidates",
  Reminder_Candidates: "List Candidate - Reminder Candidates",
  Deferred_Candidates: "List Candidate - Deferred Candidates",

  AlertsSetup: "Alerts Setup",
  Alerts_ListTemplates: "Alerts: List Templates",
  OnboardingSetup_List: "Onboarding Setup: List",
  Onboarding_Settings: "Onboarding: Settings",
  Onboarding_DocumentLibrary: "Onboarding: Document Library",
  Onboarding_Templates: "Onboarding: Templates",
  Onboarding_DocumentTypes: "Onboarding: Document Types",

  Compliance_Library: "Compliance: Compliance Library",
  Compliance_Settings: "Compliance: Compliance Settings",
  Compliance_DocummentTypes: "Compliance: Compliance Documment Types",
  Compliance_Templates: "Compliance: Compliance Templates",
  Compliance_Forms: "Compliance: Compliance Forms",
  Compliance_Teams: "Compliance: Compliance Teams",
  Compliance_Statuses: "Compliance: Compliance Statuses",
  Onboarding_Media_Library_Video: "Onboarding: Media Library Video",
  Onboarding_Media_Library_Text: "Onboarding: Media Library Text",
  Onboarding_Media_Library_Image: "Onboarding: Media Library Images",

  Compliance_OnBoardingNotifications: "Compliance: Compliance Notifications",
  Compliance_OnboardingAndComplianceDocuments: "Compliance: Onboarding/Compliance Documents",
  FeatureCompliance: "FeatureCompliance",
  Feature_OnlineDisclosure: "Feature_OnlineDisclosure",

  OnBoardingHub_OverviewTab: 'OnBoarding Hub: Overview Tab',
  OnBoardingHub_OverviewSearch: 'OnBoarding Hub: Overview Search',
  OnBoardingHub_ChangeOnBoadingStatus: 'OnBoarding Hub: Change OnBoading Status',

  OnBoardingHub_ManagerGraphsTab: 'OnBoarding Hub: Manager/Graphs Tab',
  OnBoardingHub_ManagerGraphsSearch: 'OnBoarding Hub: Manager/Graphs Search',

  OnBoardingHub_OnBoardingTab: 'OnBoarding Hub: OnBoarding Tab',
  OnBoardingHub_OnBoardingStats: 'OnBoarding Hub: OnBoarding Stats',
  OnBoardingHub_OnBoardingSearch: 'OnBoarding Hub: OnBoarding Search',
  OnBoardingHub_OnBoardingComplete: 'OnBoarding Hub: OnBoarding Complete',
  OnBoardingHub_ChangeOnBoardingAdmin: 'OnBoarding Hub: Change OnBoarding Admin',


  OnBoardingHub_ReferencesTab: 'OnBoarding Hub: References Tab',
  OnBoardingHub_ReferencesStats: 'OnBoarding Hub: References Stats',
  OnBoardingHub_ReferencesSearch: 'OnBoarding Hub: References Search',

  OnBoardingHub_ComplianceTab: 'OnBoarding Hub: Compliance Tab',
  OnBoardingHub_ComplianceStats: 'OnBoarding Hub: Compliance Stats',
  OnBoardingHub_ComplianceComplete: 'OnBoarding Hub: Compliance Complete',
  OnBoardingHub_ChangeComplianceAdmin: 'OnBoarding Hub: Change Compliance Admin',
  OnBoardingHub_ComplianceSearch: 'OnBoarding Hub: Compliance Search',
  ListCandidate_ViewGapConcernEmails: 'List Candidate - View Gap & Concern Emails',

  ListCandidate_Mark_Complete: 'List Candidate - Mark Complete',
  ListCandidate_Reset_Item: 'List Candidate - Reset Item',
  ListCandidate_GapAndConcern: 'List Candidate - Gap/Concern',
  ListCandidate_Reference_Notes: 'List Candidate - Reference Notes',
  ListCandidate_Onboarding_Notes: 'List Candidate - Onboarding Notes',
  ListCandidate_Compliance_Notes: 'List Candidate - Compliance Notes',
  ListCandidate_Book_an_Interview: 'List Candidate - Book an Interview',
  ListCandidate_Telephone_Interview: 'List Candidate - Telephone Interview',
  ListCandidate_Face_to_Face_Interview: 'List Candidate - Face-to-Face Interview',
  ListCandidate_Cancel_Reference: 'List Candidate - Cancel Reference',
  ListCandidate_MultiPanelShortlisting: 'List Candidate - Multi-Panel Shortlisting',
  RedeployeeAssignToOtherManager: "Redeployee – Assign to other Manager",
  RedeploymentCases: "Redeployment Cases",




  GeneralSetup_SchoolSubjects: "General Setup: School Subjects",
  GeneralSetup_WorkLevels: "General Setup: Work Levels",
  GeneralSetup_CostCentres: "General Setup: Cost Centres",
  ListCandidate_CompareShortlisting: "List Candidate - Compare Shortlisting",
  ListCandidate_AllowPanelShortlistingScore: "List Candidate - Allow Panel Shortlisting Score",
  ListCandidate_OnlineDisclosure: "List Candidate - Online Disclosure",
  Identity_Check: "Identity Check",
  Identity_Check_Approval: "Identity Check Approval",
  ListCandidate_DownloadCV: "List Candidate - DownloadCV",
  ListCandidate_EmailAgency: "List Candidate - Email Agency",
  MediaLibrary: "Media Library",
  MediaLibrary_Images: "Media Library: Images",
  MediaLibrary_Videos: "Media Library: Videos",
  MediaLibrary_TextualContents: "Media Library: Textual Contents",
  MediaLibrary_TextContents: "Media Library: Text Contents",
  Onboarding_AssessmentForm: "Onboarding: Assessment Form",
  ListCandidate_Reassigntorecruiter: "List Candidate - Reassign to recruiter",
  ListCandidate_RemovefromRecruiter: "List Candidate - Remove from Recruiter",
  ListCandidate_DeferredCandidate: "List Candidate - Deferred Candidate",
  SystemSettings: "System Setup: System Settings",
  OnboardingSettings: "Onboarding: Settings",
  SystemSetupSystemSettings: "System Setup: System Settings",
  SystemSetupSystemUsers: "System Setup: System Users",
  SystemSetupSecurityRoles: "System Setup: Security Roles",
  SystemSetupTeams: "System Setup:Teams",
  SystemSetupRequisitionUsers: "System Setup: Requisition Users",
  JobAuthorisationMasterTemplate: "System Setup: Job Authorisation Master Template",
  SystemSetupMultipleDocumentsUpload: "System Setup: Multiple Documents Upload",
  SystemSetupRequisitionSchemes: "System Setup: Requisition Schemes",
  AssessmentFormsAssessmentFormSetup: "Assessment Forms: Assessment Form Setup",
  AssessmentFormsQuestionsBank: "Assessment Forms: Questions Bank",
  AssessmentFormsJobType: "Assessment Forms: Job Type",
  AssessmentFormsArchivedForms: "Assessment Forms: Archived Forms",
  AssessmentFormsTimedAssessmentFormSetup: "Assessment Forms: Timed Assessment Form Setup",
  AssessmentFormsJTFormsSetup: "Assessment Forms: JT Form Setup",
  GreenRoomSetup: "Green Room Setup",
  GreenRoom: "Green Room",
  ListAlertsTemplates: "Alerts: List Templates",
  ListCandidateArchiveApplication: "List Candidate - Archive Application",
  ListCandidate_ResetTest: "List Candidate - Reset Test",
  UserSettings: "User Settings",
  CalendarIsPrivate: "CalendarIsPrivate",
  GreenRoom_Manager: "Green Room: Manager",
  GreenRoom_Links: "Green Room: Links",
  GreenRoom_Contacts: "Green Room: Key Contacts",
  ListCandidate_OAAcceptReject: "List Candidate - OA Accept & Reject",
  ListCandidate_CandidatePack: "List Candidate - Candidate Pack",
  ListCandidate_MoveToJob: "List Candidate - Move To Job",
  ListCandidate_BulkStatusUpdate: "List Candidate - Bulk Status Update",
  ListCandidate_BulkEmail: "List Candidate - Bulk Email",
  ListCandidate_ScreeningForm: "List Candidate - Screening Form",
  ListCandidate_Ranking: "List Candidate - Ranking",
  ListCandidate_PipelineDisplay: "List Candidate - Pipeline Display",
  ListCandidate_SearchByCandidateId: "List Candidate - Search By Candidate & Application Id",
  ListCandidate_ShortlistingComplete: "List Candidate - Shortlisting Complete",
  AllowAlerts: "AllowAlerts",
  AllowCalendar: "AllowCalendar",
  AllowEmails: "AllowEmails",
  AllowJobs: "AllowJobs",
  AllowLetter: "AllowLetter",
  AllowSearch: "AllowSearch",
  AllowSettingsAf: "AllowSettingsAf",
  AllowSettingsAt: "AllowSettingsAt",
  AllowSettingsGs: "AllowSettingsGs",
  AllowSettingsMl: "AllowSettingsMl",
  AllowSettingsSs: "AllowSettingsSs",
  AllowSms: "AllowSms",
  AllowTalentPools: "AllowTalentPools",
  AllowSettingsOBs: "AllowSettingsOBs",
  AllowSettingsGRs: "AllowSettingsGRs",
  ListCandidate_StartDBSCheck: "List Candidate - Start DBS Check",
  AddAjobAllowTemplate: "AddAjobAllowTemplate", //"AddAjobAllowTemplate"
  AddAjobAllowCopy: "AddAjobAllowCopy",
  AddAjobAllowCreate: "AddAjobAllowCreate",
  AddAjobAllowToCreateJobTemplate: "AddAjobAllowToCreateJobTemplate",
  GreenRoomTemplate: "Green Room: Template",
  Feature_GreenRoom: "Feature_GreenRoom",
  ViewAllJobs: "ViewAllJobs",
  ListCandidate_SubmitApplication: "List Candidate - Submit Application",
  FeatureMyJobs: "FeatureMyJobs",
  FeatureFDM: "Feature_FDM",
  FeatureCohort: "FeatureCohort",
  FeatureInternal: "FeatureInternal",
  FeatureAgency: "FeatureAgency",
  JobAdvertCopy: "JobAdvertCopy",
  FormAssessment: "FormAssessment",
  JobMatch: "JobMatch",
  JobAdditionalInfo: "JobAdditionalInfo",
  JobAccess: "JobAccess",
  JobPostTheJob: "JobPostTheJob",
  AllowListByStatuses: "AllowListByStatuses",
  SystemSetupWelcomeEmail: "System Setup: Welcome Email",
  Appliance_Settings: "Compliance: Settings",
  AllowShortlistingTelephoneForm: "Shortlisting TelephoneForm",
  AllowAcknowledgementEmail: "Acknowledgement Email",
  AllowForwardApplicationSetup: "Forward Application Setup",
  AllowCompliance: "List Candidate - Start Compliance",
  EnableCategories: "EnableCategories",
  EnableSalaries: "EnableSalaries",
  EnableRegions: "EnableRegions",
  EnableDepartment: "EnableDepartment",
  EnableLocations: "EnableLocations",
  EnableSchoolLocations: "EnableSchoolLocations",
  EnableSchoolSubjects: "EnableSchoolSubjects",
  JobSearchField: "JobSearchField",
  JobNotes: "JobNotes",
  JobApplicationForm: "JobApplicationForm",
  SourceTrackingReport: "Source Tracking Report",
  EqualOpportunityDiversityReport: "Equal Opportunity & Diversity Report",

  OfferStartersVacancyReport: "Offer & Starters/Vacancy Report",
  ListOfJobReport: "List of Jobs Report",
  InterviewReport: "Interview Report",
  InitialSiftReport: "Assessment Form Report",
  TimetoRecruitReport: "Time to Recruit Report",
  AdvertCostAnalysisReport: "Advert Cost Analysis Report",
  AgencyAnalysisReport: "Agency Analysis Report",
  CandidateStatusReport: "Candidate Status Report",
  ApplicationsPerWeekReport: "Applications Per Week Report",
  ApplicationWorkflowReport: "Application Workflow Report",
  RegistrationMethodReport: "Registration Method Report",
  BottleNeckReport: "Bottle Neck Report",
  InsightsAdvancedReport: "Insights Advanced Report",
  IsCandidateInstruction: "IsCandidateInstruction",
  GeneralSetup_DelWithdrawReason: "General Setup: Delete & Withdraw Reason",
  StatusChangeReasons: "Status Change Reasons",
  StatusChangeEmail: "Status Change Email",
  DelAndWithdrawAppReasonsReport: "Del & Withdraw App Reasons Report",
  DeleteAndWithdrawAppReasonsReport: "Delete & Withdraw Reasons Report",
  CandidateListByJobReport: "Candidate ListByJob Report",
  FeatureStatusChangeEmail: "FeatureStatusChangeEmail",
  ApplicationtoOfferReport: "Application to Offer Report",
  OnboardingReport: "Onboarding Report",
  ComplianceReport: "Compliance Report",
  ReferenceReport: "Reference Report",
  Feature_Nylas_Corporate_Account: "feature-nylas-corporate-account",
  Feature_Nylas_Personal_Account: "feature-nylas-personal-account",
  FeatureInterviewBookingInterviewerType: "feature-interview-booking-interviewer-type",
  ListCandidateBankDetails: "List Candidate – Bank Details",
  StarterDataComplete: "Starter Data Complete",
  CanChangeJobStatuses: "System Customisation: Change Job Statuses",
  CanChangeApplicationStatuses: "System Customisation: Change Application Statuses",
  CanChangeJTMobileStatuses: "System Customisation: JT Mobile Statuses",
  SendToESR: "Send to ESR",


  SystemSetupEmailInboxMasterAccount: "System Setup: Email Inbox Master Account",
  ResendToEeSS: "Resend to eESS",
  SystemSetupEmailInboxPersonalAccount: "System Setup: Email Inbox Personal Account",
  SystemSetupCalendarMasterAccount: "System Setup: Calendar Master Account",
  SystemSetupCalendarPersonalAccount: "System Setup: Calendar Personal Account",
  GBG_Enhanced: "GBG - Enhanced",
  Feature_GBG_Enhanced: "Feature_GBG_Enhanced",
  Initital_Sift_Report_Allow_EDI_Data: "Assessment Form Report – Allow EDI Data",
  ListCandidate_StarterFormNotification: "List Candidate - Starter Form Notification",
  ListCandidate_HRNetSendResend: "List Candidate – Send/Resend to HR.net",
  SendTo_iTrent: "Sent to iTrent",
  ResendToCarnivalMistral: "Re-send to Mistral",
  sendToCarnivalMistral: "Send to Mistral",
  SendToOracle: "Send to Oracle",
  Feature_OBSignature: "Feature_OBSignature",
  FeatureOnlineVideoInterview: "FeatureOnlineVideoInterview",
  Feature_TotalJobs: "Feature_TotalJobs",
  GeneralSetup_GbgOrgIDs: "General Setup: KYP OrgIDs",
  Vonq_Campaigns: "Job Board Marketplace - Campaigns",
  Feature_eEss2ndPhase: "Feature_eEss2ndPhase",
  Feature2ndStage: "Feature2ndStage",
  QillerQuestion: "QillerQuestion",
  SecondStage: "SecondStage",
  ShortListings: "ShortListings",
  FeatureAlerts: "FeatureAlerts",
  FormAdvance: "FormAdvance",
  AssessmentSettingsCog: "AssessmentSettingsCog",
  Feature_Nylas: "Feature_Nylas",
  PersonalAccount: "Email Integration: Personal Account",
  CorporateCalendar: "Email Integration: Corporate Calendar",
  CorporateInbox: "Email Integration: Corporate Inbox",
  ViewArchivedApplicationTemplates: "Application Forms: View Archived Application Forms",
  TimedAssessmentReport: "Timed Assessment Report",
  JobJobStatus: "JobJobStatus",
  RedeploymentSetting: "Redeployment Setting",
  /// security role to download all documnets in one pdf file -- for  Thirteen client///
  ListCandidate_Download: "List Candidate - Download",
  PostTheJob_JobStatus: "Post the Job - Job Status",
  JobBoards: "JobJobBoards",
  JobSocialMedia: "JobSocialMedia",
  CandidateInterviewOverrideDeleteButton: "Candidate Interview – Override Delete button",
  BrandBuilderSetting: "Brand Builder Setting",
  ListCandidate_OfferEmail: "List Candidate - Offer Email",
  DashboardTodoList: "Dashboard-Todo-List",
  ListCandidate_SendToNhsPropertyService: "List Candidate – Send To Nhs Property Service",
  Homepage_InterviewsBooked: "Homepage - Interviews booked",
  ListCandidate_InterviewComplete: "List Candidate – Interview Complete",
  CanEditTotalJobUniqueIdEditable: "IsTotalJobUniqueIdEditable",
  EqualityCommissionReport: "Equality Commission Report",
  CCMSExportRevisedReport: "CCMS Export Revised Report",
  HRBusinessPartnerComparisonReport: "HR Business Partner Comparison Report",
  RecruiterComparisonReport: "Recruiter Comparison Report",
  RecruiterComparisonGroupByReport: "Recruiter Comparison Group By Report",
  CandidateReferenceReport: "Candidate Reference Report",
  VonqProducts: "Job Board Marketplace - Products",
  StripePayment: "Stripe - Payment",
  ECNIEqualOpps: "ECNI Equal Opps",
  ChangeStatusWithoutSendingEmail: "Change Status without sending Email",
  ESRHubListVancancy: "ESR Hub - List Vacancy",
  ESRHubListApplication: "ESR Hub - List Application",
  ESRHubRemoveFromProcess: "ESR Hub - Remove From Process",
  ESRHubListEmployment: "ESR Hub - List Employment",
  ESRIntegration: "ESRIntegration",
  ESRSubmitEmploymentChecks: "ESR - Submit Employment Checks",
  FeatureShortlist: "Feature_Shortlist",
  AddNewReference: "Add Reference",
  SendToCintra: "List Candidate – Send to Cintra",
  SendToSona: "List Candidate – Send to Sona",
  SystemCustomisationChangeJobStatuses: "System Customisation: Change Job Statuses",
  SystemCustomisationChangeApplicationStatuses: "System Customisation: Change Application Statuses",
  ResendToCintra: "List Candidate – Resend to Cintra",
  AddRemove_Ob_Compliance_Items: "Add/Remove OB Compliance Items",
  GenerateOpenApiPassword: "General Setup:GenerateOpenApiPassword",
  SendToItrentIntegration: "List Candidate – Send to iTrent",
  GeneralSetupResetMFA: "General Setup - Reset MFA",

  JobAdvertECNI: "ECNI Equal Opps",

  ESRHubRemoveFromList: "ESR Hub - Remove From List",
  ESRSkipPositionDetail: "ESRSkipPositionDetail",

  ESRUpdateEmployment: "ESR - Update Employment",
  IsESRCreateVacancy: "IsESRCreateVacancy",

  PrivateJob: "Add Job - Private Job",
  PublicReportLibrary: "Build Public Reports",
  MyReports: "My Reports",
  ReportBuilder: "Report Builder",
  NTUDocumentsExtract: "List Candidate - NTU Documents",
  FeatureCRM: "feature-crm",
    ListCandidateRedeployment: "List Candidate - Redeployment",
  HomeDashboard: "Advance Dashboard",
    DashboardBuilder: "Dashboard Builder",
  FeatureAdvanceDashboard: "feature-advance-dashboard",
    GeneralSetupDashboardTemplates: "General Setup:Dashboard Templates",
    CandidateResetTwoFA: "List Candidate - Reset Two FA",
    AdvertisingPartnerAccess: "Advertising Partner - Redirect",
    IsAdvertisingPartnerEnabled: "IsAdvertisingPartnerEnabled",
  SwitchCandidateDirectApplyTemplateToStage1Template: "List Candidate - Switch Candidate Direct Apply Template To Stage1 Template"
}
export var TaskSecurityRoles = {
    JobsPendingApproval: "Tasks – Jobs Pending Approval",
    ReviewApplications: "Tasks – Review Applications",
    ReviewAttractionStrategy: "Tasks – Review Attraction Strategy",
    ArrangeInterviews: "Tasks – Arrange Interviews",
    RecordInterviewOutcomes: "Tasks – Record Interview Outcomes",
    UpcomingIntervews: "Tasks – Upcoming Intervews",
    OffersToPrepare: "Tasks – Offers to Prepare",
    ReviewReferences: "Tasks – Review References",
    ChaseReferences: "Tasks – Chase References",
    RequestFurtherReferences: "Tasks – Request Further References",
    ChaseOnboarding: "Tasks – Chase Onboarding",
    ChaseCompliance: "Tasks – Chase Compliance",
    ChaseGapAndConcern: "Tasks – Chase Gap & Concern",
    PrepForNewStarters: "Tasks – Prep for New Starters",
    ReviewOnboarding: "Tasks – Review Onboarding Task",
    ReviewCompliance: "Tasks – Review Compliance Task",
}
export var ClientDivisionItem = {
  Feature_MultiDocs: "FeatureMultiDocs",
  FeatureTextKernel: "FeatureTextKernel",
  FeatureOnboarding: "FeatureOnboarding",
  FeatureCalendar: "FeatureCalendar",
}

export var SecurityRoleMainMenu = {
  Search: "Search",
  Reports: "Reports",
  JobsAndTalentPools: "Jobs & Talent Pools",
  Calendar: "Calendar",
  Settings: "Settings",
  SettingsControl: "SettingsControl",
  //  Reports
  //Search

  //Jobs & Talent Pools
  //Communications
  //My Workspace

}

export var SecurityRoleSubMenu = {
  AlertsSetup: "Alerts Setup",
  ApplicationTemplates: "Application Templates",
  //Assessment Forms
  //Candidates
  Emails: "Emails",
  //General Setup
  //Gernal Setup
  //Green Room
  //Job Alerts
  Letters: "Letters",
  //Media Library
  //Onboarding Setup
  SMS: "SMS"
  //System Setup
}
export var WhiteLabelSecuritySettings = {

  SelfServiceCalendar: "SelfServiceCalendar",
  AlertModule: "AlertModule",
  secondStage: "2ndStage",
  AssessmentForms: "AssessmentForms",
  Forwardapplication: "Forwardapplication",
  AcknowledgementEmail: "AcknowledgementEmail",
  SmartMatch: "SmartMatch",
  ApprovalForm: "ApprovalForm",
  InternalAdvert: "InternalAdvert",
  AgencyAdvert: "AgencyAdvert",
  Agencies: "Agencies",
  Shortlister: "Shortlister",
  Agency: "Agency",
  Division: "Division",
  Skills: "Skills",
  PreAssessmentForm: "Pre-Assessment Form",
  Shortlisting: "Shortlisting",
  Competency: "Competency",
  CandidateTypeFilter: "CandidateTypeFilter",

  // ListOfJobsReport: "ListOfJobsReport",
  // OfferStartersVacancyReport: "OfferStartersVacancyReport",
  InitialSiftReport: "AssessmentFormsReport",
  AdvertCostAnalysisReport: "AdvertCostAnalysisReport",
  AgencyAnalysisReport: "AgencyAnalysisReport",
  ApplicationWorkflowReport: "ApplicationWorkflowReport",
  InsightsAdvancedReport: "InsightsAdvancedReport",
  ManageCalendarEvents: "ManageCalendarEvents",
  NewCalendarEvents: "NewCalendarEvents",



}

export var MediaRichEnum = {
  image250: "assets/images/250x250.jpg",
  image750: "assets/images/750x250.jpg",
}
